
import { makeDataForModel } from './relief'

// 源文件生成器，产出一个blob
function SourceExporter() {
    this.canvas = document.createElement("canvas");
    this.context = this.canvas.getContext("2d");
}

SourceExporter.RedChannelRatio = 0.299 / 255;
SourceExporter.GreenChannelRatio = 0.587 / 255;
SourceExporter.BlueChannelRatio = 0.114 / 255;

// 生成blob
SourceExporter.prototype.makeBlob = function (draw) {
    // 提升精度
    // let oldImageWidth = draw.imageWidth; // 保存宽度
    // draw.imageWidth = 1200;
    let { w, h, h2, paddingRealLeftRight, paddingRealTopBottom, cellSize, data } = makeDataForModel(draw);
    // draw.imageWidth = oldImageWidth; // 复原宽度

    // 计算数组长度
    let n_bytes = 4; // w
    n_bytes += 4; // h
    n_bytes += 8; // paddingRealLeftRight
    n_bytes += 8; // paddingRealTopBottom
    n_bytes += 8; // cellSize
    n_bytes += 8; // width
    n_bytes += 8; // height2
    n_bytes += 8; // reliefHeight
    n_bytes += 8; // thickness;
    n_bytes += w * h * 4; // depthData
    // n_bytes += w * h * 3 * 4; // colors，色彩信息，三个颜色。
    
    // 创建数组和输出器
    let buffer = new ArrayBuffer(n_bytes);
    let writer = new DataView(buffer);

    // 写入浮雕部分数据
    let index = 0;
    writer.setInt32(index, w, true);
    index += 4;
    writer.setInt32(index, h, true);
    index += 4;
    writer.setFloat64(index, paddingRealLeftRight, true);
    index += 8;
    writer.setFloat64(index, paddingRealTopBottom, true);
    index += 8;
    writer.setFloat64(index, cellSize, true);
    index += 8;
    writer.setFloat64(index, draw.width, true);
    index += 8;
    writer.setFloat64(index, draw.height2, true);
    index += 8;
    writer.setFloat64(index, draw.height, true);
    index += 8;
    writer.setFloat64(index, draw.thickness, true);
    index += 8;
    let data_index = 0;
    for (let j = 0; j < h; j++) {
        for (let i = 0; i < w; i++) {
            let grey = data.data[data_index] * SourceExporter.RedChannelRatio
                + data.data[data_index + 1] * SourceExporter.GreenChannelRatio
                + data.data[data_index + 2] * SourceExporter.BlueChannelRatio;
            writer.setFloat32(index, grey, true);
            index += 4;
            data_index += 4;
        }
    }
    
    return new Blob([buffer], { type: "application/octet-binary" });
}

export {
    SourceExporter
}




// WEBPACK FOOTER //
// ./src/views/mobilPhoneShell3d/scripts/SourceExporter.js